"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestEvents = void 0;
var events_1 = require("events");
var Logger_1 = __importDefault(require("../Logger"));
var TestEvents;
(function (TestEvents) {
    TestEvents["COMPLETED"] = "completed";
    TestEvents["START"] = "start";
    TestEvents["RESULT"] = "result";
    TestEvents["PROGRESS"] = "progress";
    TestEvents["ERROR"] = "error";
})(TestEvents || (exports.TestEvents = TestEvents = {}));
var Test = /** @class */ (function (_super) {
    __extends(Test, _super);
    function Test() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.completed = false;
        _this.started = false;
        _this.result = 0;
        _this.startTime = null;
        _this.timeoutTime = 12000;
        _this.name = null;
        _this.warnings = [];
        _this.errors = [];
        _this.abort = function (failed) {
            if (failed === void 0) { failed = false; }
            clearInterval(_this.errorTimer);
            clearInterval(_this.timer);
            if (_this.completed) {
                return;
            }
            _this.cleanup();
            _this.completed = true;
            Logger_1.default.log("Abort ".concat(_this.name, " test"));
            if (failed) {
                _this.emit(TestEvents.ERROR, {
                    testName: _this.name,
                    error: 'Task failed to complete',
                });
            }
            else {
                _this.emit(TestEvents.COMPLETED);
            }
        };
        return _this;
    }
    Test.prototype.start = function () {
        Logger_1.default.log('Start test', this.name);
        this.errorTimer = setTimeout(this.abort, this.timeoutTime);
        this.onStart();
    };
    Test.prototype.onStart = function () {
        this.emit(TestEvents.START, { testName: this.name });
    };
    Test.prototype.done = function (result) {
        if (typeof result === 'number') {
            this.result = result;
        }
        this.completed = true;
        clearInterval(this.errorTimer);
        clearInterval(this.timer);
        this.cleanup();
        this.reportResult();
        this.emit(TestEvents.COMPLETED);
    };
    // eslint-disable-next-line class-methods-use-this
    Test.prototype.cleanup = function () {
        // Override in test
    };
    Test.prototype.reportResult = function () {
        this.emit(TestEvents.RESULT, {
            testName: this.name,
            result: this.result,
            warnings: this.warnings,
            errors: this.errors,
        });
    };
    return Test;
}(events_1.EventEmitter));
exports.default = Test;
//# sourceMappingURL=Test.js.map